<template>
  <div class="container">
    <div class="text">404 找不到页面
      <router-link to="/" class="back">回到首页...</router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: "404"
  }
</script>

<style scoped>
  .container {
    width: 100%;
    height: calc(100vh - 64px);
    text-align: center;
  }
  .text{
    margin: 0 auto;
    font-size: 40px;
    line-height: 120px;
  }
  .back{
    text-decoration: none;
    color: #216cb0;
  }
</style>



// WEBPACK FOOTER //
// src/components/infoPage/404.vue